// Vue 3: Use vue-clipboard3 instead of vue-clipboard2
import useClipboard from "vue-clipboard3"

// Get the toClipboard function from the composable
const { toClipboard } = useClipboard()

// Vue 3: Export for use in components
export { toClipboard }

// Plugin for backward compatibility
export default {
  install(app) {
    app.config.globalProperties.$copyText = async (text) => {
      try {
        await toClipboard(text)
        return true
      } catch (e) {
        console.error("Failed to copy text:", e)
        return false
      }
    }
  },
}
